import React, { useCallback, useMemo } from 'react';
import { Modal, Tabs } from 'antd';
import { useDispatch } from 'react-redux';
import Cookies from 'js-cookie';
import classNames from 'classnames';
import TabVideo from './components/TabVideo';
import TabInteractiveTour from './components/TabInteractiveTour';
import {
  preferredSubdomainCookieName,
  redirectToSubdomain
} from '@components/OrganizationBoundary';
import { useIsDemoOrganization } from '@hooks/useIsDemoOrganization';
import './BootcampModal.less';
import { toggleBootcampModal } from '@redux/actions/modalAction';
import { BootcampModalStateProps } from '@redux/types/modalType';
import { CrossIcon } from '@icons';

export default function BootcampModal({
  visible,
  defaultTab = 'video'
}: BootcampModalStateProps) {
  const dispatch = useDispatch();
  const isDemoOrganization = useIsDemoOrganization();

  const onCloseModal = useCallback(() => {
    dispatch(toggleBootcampModal({ visible: false }));
    if (isDemoOrganization)
      redirectToSubdomain(
        Cookies.get(preferredSubdomainCookieName) || 'demo-over',
        'campaigns/all'
      );
  }, [dispatch, isDemoOrganization]);

  const tabsItems = useMemo(() => {
    return [
      {
        label: 'Video',
        key: 'video',
        children: <TabVideo />
      },
      {
        label: 'Interactive Tour',
        key: 'interactiveTour',
        children: (
          <TabInteractiveTour
            onCloseModal={() =>
              dispatch(toggleBootcampModal({ visible: false }))
            }
          />
        )
      }
    ];
  }, [dispatch]);

  return (
    <Modal
      open={visible}
      footer={null}
      centered={true}
      width={1032}
      destroyOnClose
      zIndex={999}
      bodyStyle={{ height: 'auto' }}
      onCancel={() => onCloseModal()}
      className={classNames('bootcamp-modal')}
    >
      <CrossIcon className="bootcamp-modal-btn-close" onClick={onCloseModal} />
      <Tabs
        defaultActiveKey={defaultTab || 'video'}
        tabPosition="left"
        items={tabsItems}
        className="bootcamp-modal_tabs"
      />
    </Modal>
  );
}
